import { userGroupRolesQuery } from "~/graphql/queries/userGroupRoles";
import { userTeamsRolesQuery } from "~/graphql/queries/userTeamsRoles";
import { store } from "~/store";
import { apolloClient } from "~/vue-apollo";

/**
 * Check if a user has roles.
 * @param {string} userId
 * @param {string[]} roles
 */
export async function hasRoles(userId, roles) {
  const response = await apolloClient.query({
    query: userGroupRolesQuery,
    variables: { id: userId },
  });

  if (!response?.data?.user?.userGroup) {
    return false;
  }

  return roles.every((role) => response.data.user.userGroup.roles.includes(role));
}

/**
 * Check if a user one of the supplied roles.
 * @param {string} userId
 * @param {string[]} roles
 */
export async function hasRole(userId, roles) {
  const response = await apolloClient.query({
    query: userGroupRolesQuery,
    variables: { id: userId },
  });

  if (!response?.data?.user?.userGroup) {
    return false;
  }

  return roles.some((role) => response.data.user.userGroup.roles.includes(role));
}

export async function hasTeamRole(currentUserId, role, userId) {
  const response = await apolloClient.query({
    query: userTeamsRolesQuery,
    variables: { id: userId },
  });

  switch (role) {
    case "LeaveAdmin":
      return response.data.user.userTeams.some((team) => team.leaveAdminIds.some((id) => id.toString() === currentUserId.toString()));
    case "SickNoteAdmin":
      return response.data.user.userTeams.some((team) => team.sickNoteAdminIds.some((id) => id.toString() === currentUserId.toString()));
    case "TimeRegistrationApprover":
      return response.data.user.userTeams.some((team) => team.timeRegistrationApproverIds.some((id) => id.toString() === currentUserId.toString()));
    default:
      return false;
  }
}

export async function logOutUserAndResetApp() {
  await store.dispatch("session/signOut");

  // clearStore rejects every query still in flight, and its own promise rejects
  // with them. Left floating it becomes an unhandled rejection, which is how
  // signing out reported itself to Sentry. Cancelling them is the point of the
  // call, so there is nothing to report.
  await apolloClient.clearStore().catch(() => {});
}

export function getLogoutUrl() {
  return store.getters["session/tokenData"]?.logoutUrl;
}
